import * as React from 'react';
import Login from './pages/LoginPage';
import ProviderLogin from './pages/ProviderLoginPage';
import ForgotPassword from './pages/ForgotPasswordPage';
import ResetPassword from './pages/ResetPasswordPage';
import SignUp from './pages/SignUpPage';

import {
    FORGOT_PATH,
    LOGIN_PATH,
    PROVIDER_AUTHORIZED_PATH,
    PROVIDER_LOGIN_PATH,
    PROVIDER_LOGIN_PROVIDER_PATH,
    RESET_PATH,
    SETUP_MFA_PATH,
    SETUP_MFA_RECOVERY_PATH,
    SIGNUP_PATH,
} from './constants';
import { canCreateUser } from '../users/utils';
import SetupMfaPage from './pages/SetupMfaPage.tsx';
import SetupMfaRecoveryPage from './pages/SetupMfaRecoveryPage.tsx';

export default [
    {
        path: LOGIN_PATH,
        loginRequired: false,
        component: Login,
    },
    {
        path: PROVIDER_LOGIN_PATH,
        loginRequired: false,
        component: ProviderLogin,
    },
    {
        path: PROVIDER_LOGIN_PROVIDER_PATH,
        loginRequired: false,
        component: ProviderLogin,
    },
    {
        path: PROVIDER_AUTHORIZED_PATH,
        loginRequired: false,
        component: (props) => <ProviderLogin providerAuthorized={true} {...props} />,
    },
    {
        path: FORGOT_PATH,
        loginRequired: false,
        component: ForgotPassword,
    },
    {
        path: RESET_PATH,
        loginRequired: false,
        component: ResetPassword,
    },
    {
        path: SIGNUP_PATH,
        component: SignUp,
        condition: ({ user }) => canCreateUser(user),
    },
    {
        path: SETUP_MFA_PATH,
        component: SetupMfaPage,
        mfaRequired: false,
    },
    {
        path: SETUP_MFA_RECOVERY_PATH,
        component: SetupMfaRecoveryPage,
        mfaRequired: false,
    },
];
